/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs */

const en__field__enum_teachingsubjectinterest_subject_latin14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latin`)
};

const de__field__enum_teachingsubjectinterest_subject_latin14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latein`)
};

/**
* | output |
* | --- |
* | "Latin" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_latin14 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Latin14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_latin14(inputs)
	return de__field__enum_teachingsubjectinterest_subject_latin14(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_latin14 as "_field__enum_teachingSubjectInterest_SUBJECT_LATIN" }